import React from 'react';
import './Box.css'

function Box({link, children}) {
    return (
        <div className="col-12 col-sm-6 col-md-4 col-lg-3">
            <a target={"_blank"} rel={"noopener noreferrer"} href={link}><div className="box">
            <div>
                {children}
            </div>
            </div></a>
        </div>
    );
}

export default Box;


// WEBPACK FOOTER //
// ./src/frontend/component/box/Box.js